import { ParseQuery } from './parse-query';

import { City } from './../data';

export class CityQuery extends ParseQuery<City> {
  constructor() {
    super(City);
  }
}